import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17cecdf1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rel my-switch" }
const _hoisted_2 = { class: "abs on no-event" }
const _hoisted_3 = { class: "abs off no-event" }


import { isD2C } from '@/store'

export default /*#__PURE__*/_defineComponent({
  props: ['modelValue'],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_switch, _mergeProps({ "model-value": __props.modelValue }, _ctx.$attrs, {
      "active-color": _unref(isD2C)() ? '#004C3F' : '#1B66AD',
      "inactive-color": "#E5E5E5"
    }), null, 16, ["model-value", "active-color"]),
    _withDirectives(_createElementVNode("i", _hoisted_2, null, 512), [
      [_vShow, __props.modelValue]
    ]),
    _withDirectives(_createElementVNode("i", _hoisted_3, null, 512), [
      [_vShow, !__props.modelValue]
    ])
  ]))
}
}

})